import Hero from "../components/Hero";
import Carousel from "../components/Carousel";
import Reviews from "../components/Reviews";
import OrderCallout from "../components/OrderCallout";
import DineIn from "../components/DineIn";
import ContactBar from "../components/ContactBar";

export default function Home() {
    return (
        <>
            <Hero />
            <Carousel />
            <Reviews />
            <OrderCallout />
            <DineIn />
            <ContactBar />
        </>
    );
}
